/** FMS 請款 rounding_mode（異於採購 UP／DOWN） */
export const FMS_ROUNDING_MODE = {
  HALF_UP: 'HALF_UP',
  CEILING: 'CEILING',
  FLOOR: 'FLOOR',
};

export const FMS_ROUNDING_MODE_OPTIONS = [
  { value: FMS_ROUNDING_MODE.HALF_UP, label: '四捨五入' },
  { value: FMS_ROUNDING_MODE.CEILING, label: '無條件進位' },
  { value: FMS_ROUNDING_MODE.FLOOR, label: '無條件捨去' },
];

export const PAYMENT_REQUEST_STATUS_LABEL = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  FINANCE_PROCESSING: '財務處理中',
  RETURNED: '已退回',
  APPROVED: '已核准',
  PAID: '已撥款',
  RECEIVED: '已領收',
  CLOSED: '已結案',
  CANCELLED: '已取消',
};

export const PAYMENT_REQUEST_STATUS_FILTER_OPTIONS = Object.entries(
  PAYMENT_REQUEST_STATUS_LABEL,
).map(([value, label]) => ({ value, label }));

export const PAYMENT_REQUEST_LIST_SORT_FIELD_LABELS = {
  requestNo: '請款單號',
  paymentReason: '事由',
  status: '狀態',
  totalAmount: '總額',
  updatedAt: '更新時間',
  updated_at: '更新時間',
  request_no: '請款單號',
};

export function formatPaymentRequestStatusLabel(status) {
  return PAYMENT_REQUEST_STATUS_LABEL[status] ?? status ?? '—';
}

export function canEditPaymentRequest(status) {
  return status === 'DRAFT' || status === 'RETURNED' || !status;
}

export function canDeletePaymentRequest(status) {
  return status === 'DRAFT';
}

export function formatRoundingModeLabel(mode) {
  return FMS_ROUNDING_MODE_OPTIONS.find((option) => option.value === mode)?.label
    ?? mode ?? '—';
}

export function canSubmitPaymentRequest(status) {
  return status === 'DRAFT' || status === 'RETURNED';
}

export function canStartProcessingPaymentRequest(status) {
  return status === 'SUBMITTED';
}

export function canReviewPaymentRequest(status) {
  return status === 'FINANCE_PROCESSING';
}

export function canPayPaymentRequest(status) {
  return status === 'APPROVED';
}

/** 另須是該筆 payee 本人（後端驗證） */
export function canReceivePaymentRequest(status) {
  return status === 'PAID';
}

export function canClosePaymentRequest(status) {
  return status === 'RECEIVED';
}

/** DRAFT 用刪除草稿；APPROVED 之後不可取消 */
export function canCancelPaymentRequest(status) {
  return status === 'SUBMITTED'
    || status === 'FINANCE_PROCESSING'
    || status === 'RETURNED';
}
